<template>
  <div class="program-list-component">
    <div v-if="list.length > 0"
         class="program-list"
    >
      <ym-program-item v-for="(item, index) in list"
                       :key="`id-${item.id}-${index}`"
                       :hide-icon="hideIcon"
                       :audio-type="audioType"
                       :playing-id="player.playingId"
                       :item="item"
                       :index="index"
                       :show-audio-title = "showAudioTitle"
                       :list-type="listType"
                       :record-type="recordType"
                       v-ym-report:[recordName]="item"
                       @click-cover="handleClick"
                       @click-content="handleShowProgramDetail"
      />
    </div>
    <div v-else-if="showEmpty"
         class="empty"
    >
      暂无大纲
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';
  import ProgramItem from '@/pages/AudioProgram/components/ProgramListItem';
  import { isIosWebView, handleRunAppFn } from '@/utils';

  export default {
    name: 'ProgramListComponent',
    components: {
      'ym-program-item': ProgramItem,
    },
    props: {
      hideIcon: {
        type: Boolean,
        default: false,
      },
      list: {
        type: Array,
        required: true,
        default() {
          return [];
        },
      },
      audioType: {
        type: String,
        required: true,
      },
      order: {
        type: String,
        default: 'desc',
      },
      showAudioTitle: {
        type: Boolean,
        default: false,
      },
      listType: {
        type: String,
        default: 'program',
      },
      recordType: {
        type: String,
      },
      showEmpty: Boolean,
    },
    data() {
      return {
        loading: false,
        isSetList: false,
      };
    },
    computed: {
      ...mapGetters([
        'player',
      ]),
      playerLoading() {
        return this.player.getLoadingStatus() === 'loading';
      },
      recordName() {
        if (this.recordType === 'learning') return 'LEARNING_AUDIO_CLICK';
        return '';
      },
    },
    watch: {
      list() {
        this.isSetList = false;
      },
    },
    methods: {
      setPlaylist() {
        this.isSetList = true;
      },
      async handleClick(item) {
        const { id } = item;
        if (isIosWebView()) {
          try {
            await handleRunAppFn('audioProgramDetail', { id });
          } catch (e) {
            this.handleGoProgramDetail(id);
          }
        } else {
          this.handleGoProgramDetail(id);
        }
      },
      setPlayStatus(id, status) {
        const { list } = this;
        const item = list.find(i => i.id === id);
        if (item == null) return;
        if (item.playStatus === 'played') return;
        item.playStatus = status;
      },
      handlePlayNext(id) {
        const { isSetList, player, list } = this;
        // 获取当前index
        const currentIndex = list.findIndex(i => i.id === id);
        // 非当前列表，则return 函数
        if (currentIndex === -1) return;
        // 未更新播放列表
        if (!isSetList) {
          this.setPlaylist();
        }
        // 获取下一首index
        const nextIndex = currentIndex + 1;
        if (nextIndex === list.length) return;
        // 获取下一首
        const next = list.find((i, index) => index === nextIndex);
        const { playingId } = player;
        if (playingId !== next.id) {
          // 播放下一首
          player.play(nextIndex);
        }
      },
      setPlayerListener() {
        const { player } = this;

        // 开始播放则至为未学完状态
        const startListener = player.on('audioPlay', (source) => {
          const { id } = source;
          // 设置播放状态
          this.setPlayStatus(id, 'playing');
        });

        // 播放结束则至为播放完状态
        const endListener = player.on('audioEnded', (source) => {
          const { id } = source;
          // 设置播放状态
          this.setPlayStatus(id, 'played');
        });

        const canNextListener = player.on('canAutoNext', (source) => {
          const { id } = source;
          // 处理下一首
          this.handlePlayNext(id);
        });

        // destroy 实例
        this.$once('hook:beforeDestroy', () => {
          player.off('audioPlay', startListener);
          player.off('audioEnded', endListener);
          player.off('canAutoNext', canNextListener);
        });
      },
      async handleShowProgramDetail(item) {
        if (this.player.playingId > 0) {
          this.player.pause();
        }
        await this.$store.dispatch('toggleGlobalPlayList', []);
        const { id } = item;
        if (isIosWebView()) {
          try {
            await handleRunAppFn('audioProgramDetail', { id });
          } catch (e) {
            this.handleGoProgramDetail(id);
          }
        } else {
          this.handleGoProgramDetail(id);
        }
      },
      handleGoProgramDetail(id) {
        const route = { name: 'AudioProgramDetail', params: { id } };
        this.$router.push(route);
      },
    },
    created() {
      this.isSetList = false;
      this.setPlayerListener();
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .program-list {
    padding: 0;
    margin: 0;
  }
</style>
